// Apolo renderer — agentLoop spine helper: System One autonomy gate step (E3).
//
// Extracted OUT of the runLocalAgentLoop spine (dp-loc ratchet: the spine must
// not grow). Holds the flag check, the dynamic imports, the mutating check and
// the event emission so the spine stays a single call.
//
// Additive + flag-gated (apolo_so_autonomy). Reversible tools are never gated.
// Advisory: never hard-blocks — it can only UPGRADE reviewDecision to 'ask'.
// Fail-open on any error (keeps the current reviewDecision).

import { readFlagDefaultOff } from '../../flags/sprintFlags.js';
import { MUTATING_TOOLS, describeToolCall } from '../../agentTools.js';

/**
 * @param {object} tc  the tool call { id, name, arguments }
 * @param {object} repairedArgs
 * @param {any} reviewDecision  current review decision ('allow'|'ask'|'block'|null)
 * @param {Map} extraByName  registry of extra tools (for the `mutating` flag)
 * @param {Function} onEvent
 * @returns {Promise<any>} the (possibly upgraded) reviewDecision
 */
export async function autonomyGateStep(tc, repairedArgs, reviewDecision, extraByName, onEvent) {
  const isMutating = MUTATING_TOOLS.has(tc.name) || extraByName.get(tc.name)?.mutating;
  if (!readFlagDefaultOff('apolo_so_autonomy') || reviewDecision === 'block' || !isMutating) {
    return reviewDecision;
  }
  try {
    const [{ gateAction }, { gateMutatingTool }] = await Promise.all([
      import('../../systemOneClient.js'),
      import('../../agentAutonomy.js'),
    ]);
    const { review, decision } = await gateMutatingTool({
      gateAction,
      describe: describeToolCall(tc.name, repairedArgs),
      isMutating: true,
      currentReview: reviewDecision,
    });
    if (decision) onEvent({ type: 'autonomy_gate', id: tc.id, name: tc.name, decision });
    return review;
  } catch {
    return reviewDecision; // fail-open
  }
}
